import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Check, X } from "lucide-react";

export default function PaymentResult({ status }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [pay, setPay] = useState(null);
  const [msg, setMsg] = useState("Checking payment status…");

  useEffect(() => {
    if (status !== "success" || !sessionId) return;
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") { setPay(data); setMsg("Payment successful!"); return; }
        if (data.status === "expired") { setMsg("Payment session expired."); return; }
        if (attempts < 6) setTimeout(poll, 2000); else setMsg("Payment is still processing. Check your email.");
      } catch { setMsg("Could not verify payment."); }
    };
    poll();
  }, [sessionId, status]);

  const success = status === "success";
  return (
    <div className="section-dark min-h-screen flex items-center py-24">
      <div className="container-app text-center">
        <div className={`inline-flex items-center justify-center w-20 h-20 border-2 ${success?"border-[color:var(--gold)] text-[color:var(--gold)]":"border-red-500 text-red-500"}`}>
          {success ? <Check size={40}/> : <X size={40}/>}
        </div>
        <h1 className="font-heading font-black uppercase text-5xl md:text-7xl mt-8 leading-none">
          {success ? <><span className="metallic-gold">Payment</span> Successful.</> : <>Payment Cancelled.</>}
        </h1>
        <p className="mt-6 text-white/70" data-testid="payment-status-msg">{success ? msg : "No charges were made."}</p>
        {pay && pay.metadata?.name && <div className="mt-4 font-mono text-sm text-white/60">Item: {pay.metadata.name}</div>}
        <div className="mt-10 flex justify-center gap-4">
          <Link to="/" className="btn-gold" data-testid="payment-home-btn">Home</Link>
          <Link to="/dashboard" className="btn-ghost" data-testid="payment-dashboard-btn">Dashboard</Link>
        </div>
      </div>
    </div>
  );
}
